import fileDownload from 'js-file-download';

const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3995/descargar'
  : 'https://sideop-generador-word.daesaingenieria.com/descargar';

export default {
  methods: {
    async mixDescargarPlantilla(data, nombreArchivo = 'plantilla-sideop') {
      // console.log(BASE_URL);
      await this.axios.post(
        BASE_URL,
        data,
        { responseType: 'blob' },
      )
        .then((res) => {
          fileDownload(res.data, `${nombreArchivo}.docx`);
        })
        .catch((err) => {
          this.mixMensajeError(err.statusText);
        });
    },
  },
};
